<section class="email-verification" *ngIf="!isAccountVerified()">
  <p>
    To prevent your account from being locked out, please verify your email.
  </p>
  <button mat-raised-button (click)="verifyEmail()">Verify Email</button>
</section>
